import cls from 'classnames';
import OptionalLabel from 'Components/Forms/OptionalLabel';
import { Field } from 'formik';
import React from 'react';

const inputStyles =
  'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out text-sm sm:leading-5';

const TextareaField = ({ name, label = null, type = 'text', isRequired = false, hint, className, ...props }) => (
  <div>
    <OptionalLabel required={props.required || isRequired} name={name} label={label} />
    <span className="text-xs text-gray-600">{hint}</span>
    <div className="mt-1">
      <Field className={cls(inputStyles, className)} as="textarea" name={name} {...props} />
    </div>
  </div>
);

export default TextareaField;
